export const HitchpinCardTypeNames = {
  Demand: 'demand',
  Supply: 'supply',
  Storefront: 'storefront',
};
